import { Button, Empty } from "antd"

const EmptyState = ({
  title = "Nothing to show",
  description,
  actionLabel,
  onAction,
  children,
}) => {
  return (
    <div className="empty-state">
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={
          <div>
            <div className="empty-state__title">{title}</div>
            {description ? (
              <div className="empty-state__desc">{description}</div>
            ) : null}
          </div>
        }
      >
        {actionLabel && onAction ? (
          <Button type="primary" onClick={onAction}>
            {actionLabel}
          </Button>
        ) : null}
        {children}
      </Empty>
    </div>
  )
}

export default EmptyState
